export const DATA_GENERATION_HISTORY_GOOGLE_ANALYTICS_TAG = 'DataGenerationHistory';
export const TAB_NAME = 'Downloads';
